module.exports = __webpack_public_path__ + "static/media/video_placeholder.c9c87613.png";